import _toConsumableArray from "E:\\Code\\ui\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _objectSpread from "E:\\Code\\ui\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "E:\\Code\\ui\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import { useBootstrapPrefix, useBootstrapBreakpoints, useBootstrapMinBreakpoint } from './ThemeProvider';
import createUtilityClassName, { responsivePropType } from './createUtilityClasses';
import { jsx as _jsx } from "react/jsx-runtime";
var Stack = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    bsPrefix = _ref.bsPrefix,
    className = _ref.className,
    direction = _ref.direction,
    gap = _ref.gap,
    props = _objectWithoutProperties(_ref, ["as", "bsPrefix", "className", "direction", "gap"]);
  bsPrefix = useBootstrapPrefix(bsPrefix, direction === 'horizontal' ? 'hstack' : 'vstack');
  var breakpoints = useBootstrapBreakpoints();
  var minBreakpoint = useBootstrapMinBreakpoint();
  return /*#__PURE__*/_jsx(Component, _objectSpread({}, props, {
    ref: ref,
    className: classNames.apply(void 0, [className, bsPrefix].concat(_toConsumableArray(createUtilityClassName({
      gap: gap,
      breakpoints: breakpoints,
      minBreakpoint: minBreakpoint
    }))))
  }));
});
Stack.displayName = 'Stack';
export default Stack;